export const SIGNUP_NEWSLETTER_CHECKBOX_A = 'signupNewsletterCheckboxA'
export const SIGNUP_NEWSLETTER_CHECKBOX_B = 'signupNewsletterCheckboxB'
export const EMAIL_AND_PHONE_CONSENT_CHECKBOX = 'EmailAndPhoneConsentCheckbox'
export const EMAIL_CONSENT_CHECKBOX = 'EmailConsentCheckbox'
export const PHONE_CONSENT_CHECKBOX = 'PhoneConsentCheckbox'
export const EMAIL_AND_PHONE_CONSENT_CHECKBOX_NEW_USERS = 'EmailAndPhoneConsentCheckboxNewUsers'
export const EMAIL_CONSENT_CHECKBOX_NEW_USERS = 'EmailConsentCheckboxNewUsers'
export const PHONE_CONSENT_CHECKBOX_NEW_USERS = 'PhoneConsentCheckboxNewUsers'
export const TERMS_CONSENT_CHECKBOX = 'TermsConsentCheckbox'
export const GENERAL_TERMS_CONSENT = 'general-terms'
export const PRIVACY_POLICY_CONSENT = 'privacy-policy'
